import { GetAmbulatoryMedications } from 'domain/usecases/ambulatory/get-ambulatory-medications'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteGetAmbulatoryMedications
  implements GetAmbulatoryMedications
{
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  get(
    params: GetAmbulatoryMedications.Params
  ): Promise<GetAmbulatoryMedications.Model> {
    return this.ambulatoryRepository.getAmbulatoryMedications(params)
  }
}
